module.exports = __webpack_public_path__ + "img/cyberdigma.564b3d28.png";